const EXTRA_TIME_TYPES = require('../constants/serviceExtraTimeTypes')
const BOOKING_INTERVALS = require('../constants/onlineBookingIntervals')
const dayjs = require('dayjs')
const {getPricingOption} = require('./saleHelper')

class SlotsHelper {
  generateSlots({
    day,
    ranges,

    services,
    resources,

    timezone,
    staffId,
    resourceId,
    occupiedSlots,

    preferred,
    intervalType,
    bookAtLeastHours,
    allowPast
  }) {
    let lastSlot
    if (occupiedSlots && occupiedSlots.length) {
      let occupiedRanges = occupiedSlots.map(s => {
        return {start: s.startOffset, end: s.endOffsetBlocked}
      })
      ranges = this.subtractRanges(ranges, occupiedRanges)
      lastSlot = occupiedSlots[occupiedSlots.length - 1]
    }

    if (resources && resources.length) {
      let resourceRanges = []
      for (let {resourceId, busySlots} of resources) {
        resourceRanges = resourceRanges.concat(
          this.subtractRanges(ranges, busySlots).map(s => {
            return {...s, resources: [resourceId]}
          })
        )
      }
      ranges = resourceRanges

      ranges = ranges.reduce((merged, slot) => {
        let existingSlot = merged.find(
          s => s.start.valueOf() === slot.start.valueOf() && s.end.valueOf() === slot.end.valueOf()
        )
        if (!existingSlot) {
          merged.push(slot)
        } else {
          existingSlot.resources = existingSlot.resources.concat(slot.resources)
        }

        return merged
      }, [])
    }

    let servicesInfo = services.map(s => {
      let extraTime = s.service.extraTime
      let info = {
        ...getPricingOption(s.option, staffId),
        blockedTimeAfter: (extraTime.afterType === EXTRA_TIME_TYPES.BLOCK && extraTime.after) || 0,
        processingTimeAfter: (extraTime.afterType === EXTRA_TIME_TYPES.PROCESSING && extraTime.after) || 0,
        serviceId: s.service._id,
        optionId: s.option._id,
        addonsPrice: s.service.addonsPrice || 0
      }

      info.blockedDuration = info.duration + info.blockedTimeAfter
      return info
    })

    // const blockedTimeAfter = (extraTime.afterType === EXTRA_TIME_TYPES.BLOCK && extraTime.after) || 0
    // const processingTimeAfter = (extraTime.afterType === EXTRA_TIME_TYPES.PROCESSING && extraTime.after) || 0
    // const blockedDuration = duration + blockedTimeAfter
    const {totalBlockedDuration, totalPrice} = servicesInfo.reduce(
      (total, s) => {
        total.totalBlockedDuration = total.totalBlockedDuration + s.blockedDuration
        total.totalPrice = total.totalPrice + s.price + s.addonsPrice
        return total
      },
      {totalBlockedDuration: 0, totalPrice: 0}
    )

    let fitting = ranges.filter(r => r.end - r.start >= totalBlockedDuration)

    let increment
    if (intervalType === BOOKING_INTERVALS.SLOTS) {
      increment = Math.max.apply(
        null,
        servicesInfo.map(s => s.blockedDuration)
      )
    } else {
      increment = totalBlockedDuration <= 30 ? 15 : totalBlockedDuration <= 60 ? 30 : 60
    }
    let slots = []
    let earliestPossible
    if (allowPast) {
      // this is for demo data generation only
      earliestPossible = dayjs()
        .set('year', 2000)
        .toDate()
    } else {
      earliestPossible = dayjs()
        .add(bookAtLeastHours, 'hours')
        .toDate()
    }

    let startOfTheDay
    if (timezone) {
      startOfTheDay = dayjs.tz(day, 'YYYYMMDD', timezone).startOf('day')
    } else {
      startOfTheDay = dayjs(day, 'YYYYMMDD').startOf('day')
    }
    for (let range of fitting) {
      let step = 0
      let rounder = intervalType === BOOKING_INTERVALS.SLOTS ? 0 : increment - (range.start % increment)
      while (range.start + step + totalBlockedDuration <= range.end) {
        //duration
        let start = startOfTheDay.add(range.start + step, 'minute').toDate()
        if (start.valueOf() >= earliestPossible.valueOf()) {
          let end = dayjs(start)
            .add(totalBlockedDuration, 'minute')
            .toDate()

          slots.push({
            start,
            end,
            startOffset: range.start + step,
            endOffsetBlocked: range.start + step + totalBlockedDuration,
            totalPrice,
            services: this._prepareSubSlots({
              servicesInfo,
              start,
              range,
              step,
              staffId,
              preferred,
              resource: staffId && range.resources && range.resources[0]
            }),
            staff: staffId && [staffId],
            resource: resourceId && [resourceId],

            recommended:
              lastSlot && (lastSlot.end.valueOf() === start.valueOf() || lastSlot.start.valueOf() === end.valueOf())
          })
        }
        if (step === 0) {
          step += increment + rounder
        } else {
          step += increment
        }
      }
    }

    return slots
  }
  subtractRanges(rangesA, rangesB) {
    let resRanges = rangesA
    if (!rangesB) {
      return resRanges
    }
    for (let rangeB of rangesB) {
      let res = []
      for (let rangeA of resRanges) {
        if (rangeB.start < rangeA.end && rangeB.end > rangeA.start) {
          res = res.concat(this._subtract(rangeA, rangeB))
        } else {
          res = res.concat(rangeA)
        }
      }
      resRanges = res
    }
    return resRanges
  }
  _subtract(a, b) {
    let res = []
    if (b.start > a.start) {
      res.push({start: a.start, end: b.start})
    }
    if (b.end < a.end) {
      res.push({start: b.end, end: a.end})
    }
    return res
  }
  _prepareSubSlots({servicesInfo, start, range, step, staffId, resourceId, preferred, resource}) {
    return servicesInfo.reduce((sl, s) => {
      let slotStart = sl.reduce((res, s) => {
        return dayjs(res)
          .add(s.blockedDuration, 'minute')
          .toDate()
      }, start)

      let slotOffset = sl.reduce((res, s) => {
        return res + s.blockedDuration
      }, range.start + step)

      let service = {
        _id: `${slotStart.valueOf()}${staffId || resourceId}`,
        service: s.serviceId,
        option: s.optionId,
        duration: s.duration,
        price: s.price,
        priceUpto: s.priceUpto,
        addonsPrice: s.addonsPrice,
        preferred,
        start: slotStart,
        end: dayjs(slotStart)
          .add(s.blockedDuration, 'minute')
          .toDate(),
        startOffset: slotOffset,
        endOffset: slotOffset + s.duration,
        endOffsetBlocked: slotOffset + s.blockedDuration,
        blockedDuration: s.blockedDuration,
        blockedTimeAfter: s.blockedTimeAfter,
        processingTimeAfter: s.processingTimeAfter
      }
      if (resource) {
        service.resource = resource
      }
      sl.push(service)
      return sl
    }, [])
  }
}

module.exports = new SlotsHelper()
